<script>
  import { fade } from "svelte/transition"
  export let text;
</script>

<div class="tooltip" transition:fade>
  {text}
</div>

<style>
  .tooltip {
    background-color: #E0E8F6;
    position: fixed;
    bottom: 150px;
    box-shadow: 0px 2px 8px 0px #10107A29;
    left: 50%;
    transform: translate(-50%);
    border-radius: 10px;
    padding: 16px 40px 16px 40px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0em;
    color: black;
    z-index: 111111111111111111;
  }

  @media (max-width: 500px) {
    .tooltip {
      padding: 16px;
      bottom: 130px;
      font-size: 12px;
    }
  }
</style>